import React from 'react';

const Doc = ({ ...props }) => {
    return (
        // <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        //     <path
        //         fillRule="evenodd"
        //         clipRule="evenodd"
        //         d="M6 40V34H8V38H38V10H30V2H8V14H6V0H31.855L40 8.14301V40H6ZM32 3V8H37L32 3Z"
        //         fill="white"
        //         fillOpacity="0.31"
        //     />
        //     <path
        //         d="M31 16H2C0.89543 16 0 16.8954 0 18V30C0 31.1046 0.89543 32 2 32H31C32.1046 32 33 31.1046 33 30V18C33 16.8954 32.1046 16 31 16Z"
        //         fill="#3387DE"
        //     />
        //     <path
        //         fillRule="evenodd"
        //         clipRule="evenodd"
        //         d="M27.325 22.5125C26.962 22.1837 26.4898 22.0012 26 22.0005C25.6751 21.9985 25.3545 22.0757 25.0661 22.2254C24.7777 22.3751 24.5301 22.5928 24.3448 22.8598C24.1594 23.1267 24.0419 23.4347 24.0024 23.7573C23.9629 24.0798 24.0026 24.4071 24.118 24.7109C24.2334 25.0146 24.4211 25.2857 24.6649 25.5006C24.9086 25.7155 25.201 25.8678 25.5168 25.9443C25.8327 26.0208 26.1624 26.0191 26.4774 25.9395C26.7925 25.86 27.0834 25.7048 27.325 25.4875L28.435 27.1535C27.8442 27.6145 27.1358 27.9003 26.3906 27.9783C25.6453 28.0563 24.8931 27.9233 24.2197 27.5947C23.5463 27.266 22.9787 26.7547 22.5817 26.1192C22.1847 25.4836 21.9742 24.7494 21.9742 24C21.9742 23.2507 22.1847 22.5164 22.5817 21.8808C22.9787 21.2453 23.5463 20.734 24.2197 20.4054C24.8931 20.0767 25.6453 19.9437 26.3906 20.0217C27.1358 20.0997 27.8442 20.3855 28.435 20.8465L27.325 22.5125ZM17 28.0005C16.2089 28.0005 15.4355 27.7659 14.7777 27.3264C14.1199 26.8868 13.6072 26.2621 13.3045 25.5312C13.0017 24.8003 12.9225 23.9961 13.0769 23.2201C13.2312 22.4442 13.6122 21.7315 14.1716 21.1721C14.731 20.6127 15.4437 20.2317 16.2196 20.0774C16.9956 19.923 17.7998 20.0022 18.5307 20.305C19.2616 20.6077 19.8864 21.1204 20.3259 21.7782C20.7654 22.436 21 23.2094 21 24.0005C21 25.0614 20.5786 26.0788 19.8284 26.8289C19.0783 27.5791 18.0609 28.0005 17 28.0005ZM17 22.0005C16.6044 22.0005 16.2178 22.1178 15.8889 22.3376C15.56 22.5573 15.3036 22.8697 15.1522 23.2351C15.0009 23.6006 14.9613 24.0027 15.0384 24.3907C15.1156 24.7786 15.3061 25.135 15.5858 25.4147C15.8655 25.6944 16.2219 25.8849 16.6098 25.9621C16.9978 26.0392 17.3999 25.9996 17.7654 25.8483C18.1308 25.6969 18.4432 25.4405 18.6629 25.1116C18.8827 24.7828 19 24.3961 19 24.0005C19 23.4701 18.7893 22.9614 18.4142 22.5863C18.0391 22.2112 17.5304 22.0005 17 22.0005ZM8 28.0005H5V20.0005H8C9.06087 20.0005 10.0783 20.4219 10.8284 21.1721C11.5786 21.9222 12 22.9396 12 24.0005C12 25.0614 11.5786 26.0788 10.8284 26.8289C10.0783 27.5791 9.06087 28.0005 8 28.0005ZM8 22.0005H7V26.0005H8C8.53043 26.0005 9.03914 25.7898 9.41422 25.4147C9.78929 25.0396 10 24.5309 10 24.0005C10 23.4701 9.78929 22.9614 9.41422 22.5863C9.03914 22.2112 8.53043 22.0005 8 22.0005Z"
        //         fill="white"
        //     />
        // </svg>
        <svg
            viewBox="0 0 49 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs />
            <path
                id="Rounded Rectangle 822"
                d="M11 16L40 16C41.1 16 42 16.89 42 18L42 30C42 31.1 41.1 32 40 32L11 32C9.89 32 9 31.1 9 30L9 18C9 16.89 9.89 16 11 16Z"
                fill="#3387DE"
                fillOpacity="1.000000"
                fillRule="evenodd"
            />
            <path
                id="Vector"
                d="M38 21L38 19L32 19L32 29L34 29L34 25L37 25L37 23L34 23L34 21L38 21Z"
                fill="#F9FDFF"
                fillOpacity="1.000000"
                fillRule="nonzero"
            />
            <path
                id="Vector"
                d="M27 29L23 29L23 19L27 19C28.64 19 30 20.35 30 22L30 26C30 27.64 28.64 29 27 29ZM25 27L27 27C27.54 27 28 26.55 28 26L28 22C28 21.45 27.54 21 27 21L25 21L25 27Z"
                fill="#F9FDFF"
                fillOpacity="1.000000"
                fillRule="nonzero"
            />
            <path
                id="Vector"
                d="M19 19L14 19L14 29L16 29L16 26L19 26C20.1 26 21 25.1 21 24L21 21C21 19.89 20.1 19 19 19ZM16 24L16 21L19 21L19 24L16 24Z"
                fill="#F9FDFF"
                fillOpacity="1.000000"
                fillRule="nonzero"
            />
            <path
                id="Rectangle 655 copy"
                d="M15 40L15 34L17 34L17 38L47 38L47 10L39 10L39 2L17 2L17 14L15 14L15 0L40.85 0L49 8.14L49 40L15 40ZM41 3L41 8L46 8L41 3Z"
                fill="#FFFFFF"
                fillOpacity="0.310000"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default Doc;
